import script from "./UserInfor.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfor.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfor.vue?vue&type=style&index=0&id=4badb8cf&lang=css"

const __exports__ = script;

export default __exports__